import React from 'react';
import { cx } from './classNames';
import './ui.css';

/** 6 カラム基準の幅。640px 以下では全て 1 カラムに畳まれる */
export type FormSpan = 'full' | 'twothird' | 'half' | 'third' | 'sixth';

export function spanClass(span: FormSpan | undefined): string | undefined {
  return span ? `ui-formgrid__item--${span}` : undefined;
}

export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function FormGrid({ className, children, ...rest }: FormGridProps) {
  return (
    <div className={cx('ui-formgrid', className)} {...rest}>
      {children}
    </div>
  );
}

export interface FormGridItemProps extends React.HTMLAttributes<HTMLDivElement> {
  span?: FormSpan;
  children?: React.ReactNode;
}

/** Field 以外（ボタン列・注記など）をグリッドに置くためのラッパ */
export function FormGridItem({ span = 'full', className, children, ...rest }: FormGridItemProps) {
  return (
    <div className={cx(spanClass(span), className)} {...rest}>
      {children}
    </div>
  );
}
